import { createApi } from '@reduxjs/toolkit/query/react';
import { Ewallet } from 'types/ewallet';
import { VITE_API_V2_URL } from "codes";
import { axiosBaseQuery } from 'helpers/axiosbaseQuery';

interface EwalletResponse {
  data: Ewallet[];
}

interface TransactionResponse {
  data: {
    transactions: {
      transaction_id: string;
      transaction_number: string;
      effective_date: string;
      amount: number;
      currency: string;
      transaction_type: string;
      invoice_name?: string;
      invoice_id?: string;
      invoice_reference?: string;
      status?: string;
      funder_name?: string;
    }[];
    pagination: {
      current_page: number;
      last_page: number;
      total: number;
      per_page: number;
    };
  };
}

interface TransactionQueryParams {
  userId?: string;
  ewalletId?: string;
  funder_id?: string;
  page?: number;
  per_page?: number;
  sort_by?: string;
  search?: string;
  type?: string;
  status?: string;
}

export const ewalletApi = createApi({
  reducerPath: 'ewalletApi',
  baseQuery: axiosBaseQuery({
    baseUrl: `${VITE_API_V2_URL}/dashboard`,
  }),
  tagTypes: ['EWALLETS', 'EWALLET_TRANSACTIONS'],
  endpoints: (builder) => ({
    getDashboardEwallets: builder.query<EwalletResponse, { userId?: string; funder_id?: string }>({
      query: (params) => {
        const queryParams = new URLSearchParams();
        
        if (params.funder_id) {
          queryParams.append('funder_id', params.funder_id);
        }
        
        const queryString = queryParams.toString();
        return { 
          url: `/ewallets${queryString ? `?${queryString}` : ''}`,
          method: "get" 
        };
      },
      transformResponse: (response) => response,
      providesTags: ["EWALLETS"],
    }),

    getEwalletTransactions: builder.query<any, { transparams: any }>({
      query: ({ transparams }) => {
        return {
          url: `/transactions?${transparams}`,
          method: "GET",
        };
      },
      transformResponse: (response) => response?.data,
      providesTags: ["EWALLET_TRANSACTIONS"],
    }),
  }),
});

export const {
  useGetDashboardEwalletsQuery,
  useGetEwalletTransactionsQuery,
} = ewalletApi;
